import "../../../styles/login.scss";

import Icon, {iconColor, iconTypes} from "./Icon.jsx";

import {Localization} from "../util/localization.jsx";
import PropTypes from "prop-types";
import React from "react";
import ResponsiveColumn from "./ResponsiveColumn.jsx";
import ResponsiveRows from "./ResponsiveRows.jsx";
import TextField from "./TextField.jsx";

import bg from "../../../assets/images/bg.png";
import logo from "../../../assets/images/engrospartner_logo.png";
import {withRouter} from "react-router-dom";

class ResetPasswordPage extends React.PureComponent {
    constructor(props){
        super(props);
        this.state = {
            cusNo: "",
            password1: "",
            password2: "",
        };

        this.onChange = this.onChange.bind(this);
        this.setNewPassword = this.setNewPassword.bind(this);
        this.onClickCancel = this.onClickCancel.bind(this);

        this.validateBothPasswords = this.validateBothPasswords.bind(this);
    }

    UNSAFE_componentWillMount() {
        this.props.setCurrentLanguage("no");
    }

    onChange(change) {
        this.setState(change);
    }

    setNewPassword(event) {
        event.stopPropagation();
        event.preventDefault();

        if( this.validateBothPasswords(this.state.password2) && this.state.cusNo.length>0 ) {
            this.props.setNewPassword(
                this.props.history,
                this.props.resetPasswordToken,
                this.state.cusNo,
                this.state.password1
            );
        }
    }

    onClickCancel(event) {
        event.stopPropagation();
        event.preventDefault();
        this.props.history.replace("/dashboard");
    }

    validateBothPasswords(password2) {
        return this.props.validatePassword(this.state.password1) && this.state.password1===password2;
    }

    render(){
        const {
            localization,
            validateCusNo,
            validatePassword,
        } = this.props;

        const isPasswordEqualAndLegal = this.validateBothPasswords(this.state.password2);
        const canSubmit = isPasswordEqualAndLegal && this.state.cusNo && this.state.cusNo.length>0;

        const NotLongEnough = this.state.password1==null || this.state.password1.length<8;
        const notContainingLowercase = this.state.password1==null || !this.state.password1.match(/[a-zæøåäöÆàéèêóÒô]/g);
        const notContainingUppercase = this.state.password1==null || !this.state.password1.match(/[A-ZØÅÄÖÀÉÈÊÓÒÔ]/g);
        const notContainingNumber = this.state.password1==null || !this.state.password1.match(/[0-9]/g);

        return (
            <React.Fragment>
                <div className="login-background">
                    <img src={bg} className="login-background-img"/>
                </div>
                <div className="login-engrospartner-logo">
                    <img src={logo} />
                </div>
                <div className="login-wrapper card-default">
                    <ResponsiveRows>
                        <ResponsiveColumn xs={12}>
                            <div className="header-wrapper">
                                <Icon type={iconTypes.circleQuestion} className="header-icon"/>
                                <div className="header-text">
                                    {localization.text("changePassword","enterNewPassword")}
                                </div>
                            </div>
                        </ResponsiveColumn>
                    </ResponsiveRows>
                    <div className="hr"/>
                    <form disabled={!canSubmit} onSubmit={this.ressetPassword}>
                        <ResponsiveRows>
                            <ResponsiveColumn xs={12}>
                                <TextField onEdit={this.onChange} onChange={this.onChange} iconType={iconTypes.account} source={this.state} property={"cusNo"} placeholder={localization.text("login","customerid")} disabled={false} autoComplete="new-password" validation={validateCusNo}/>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={12}>
                                <TextField onEdit={this.onChange} onChange={this.onChange} type={"password"} iconType={iconTypes.key} source={this.state} property={"password1"} placeholder={localization.text("changePassword","newPassword")} autoComplete="new-password" validation={validatePassword} disabled={false}/>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={12}>
                                <TextField onEdit={this.onChange} onChange={this.onChange} type={"password"} iconType={iconTypes.key} source={this.state} property={"password2"} placeholder={localization.text("changePassword","repeatPassword")} autoComplete="new-password" validation={this.validateBothPasswords} disabled={!validatePassword(this.state.password1)}/>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={12}>
                                <label className="password-hint">
                                    <Icon type={NotLongEnough?iconTypes.starFilled:iconTypes.checkLarge} color={NotLongEnough?iconColor.red:iconColor.dark} className="password-requires"/>
                                    {localization.text("changePassword","passwordMinLength")}
                                </label>
                                <label className="password-hint">
                                    <Icon type={notContainingLowercase?iconTypes.starFilled:iconTypes.checkLarge} color={notContainingLowercase?iconColor.red:iconColor.dark} className="password-requires"/>
                                    {localization.text("changePassword","passwordNeedUppercase")}
                                </label>
                                <label className="password-hint">
                                    <Icon type={notContainingUppercase?iconTypes.starFilled:iconTypes.checkLarge} color={notContainingUppercase?iconColor.red:iconColor.dark} className="password-requires"/>
                                    {localization.text("changePassword","passwordNeedLowercase")}
                                </label>
                                <label className="password-hint">
                                    <Icon type={notContainingNumber?iconTypes.starFilled:iconTypes.checkLarge} color={notContainingNumber?iconColor.red:iconColor.dark} className="password-requires"/>
                                    {localization.text("changePassword","passwordNeedNumber")}
                                </label>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={12}>
                                <div className={"login-reset-pass-button-spacer"}>
                                    <button className={"btn primary block"} disabled={!canSubmit} onClick={this.setNewPassword}>
                                        {localization.text("changePassword","savePassword")}
                                    </button>
                                </div>
                            </ResponsiveColumn>
                        </ResponsiveRows>
                    </form>
                </div>
                <div className="login-copyright-notice" >
                    Kolly Tool 2019 @ All rights reserved.
                </div>
            </React.Fragment>
        );
    }
}

ResetPasswordPage.propTypes = {
    setCurrentLanguage: PropTypes.func.isRequired,
    localization: Localization.propTypes.isRequired,
    resetPasswordToken: PropTypes.string,
    loggingIn: PropTypes.bool,
    history: PropTypes.object,
    setNewPassword: PropTypes.func.isRequired,
    validateCusNo: PropTypes.func.isRequired,
    validatePassword: PropTypes.func.isRequired,
};

export default withRouter(ResetPasswordPage);